<template>
  <HeaderContent title="Reservation"/>
  <ActionContent ctaText="Add Reservation" @action="modal = !modal" @showFilter="modalFilter = !modalFilter"/>
  <ReservationStatistic title="Reservation Statistics" :data="statistics"/>
  <ReservationForm :modal="modal" @update:modal="modal = $event"/>
  <ReservationFilter :modalFilter="modalFilter" @update:modalFilter="modalFilter = $event"/>
  <ReservationConfirm title="Confirmation" :modalConfirm="modalConfirm" @update:modalConfirm="modalConfirm = $event">
    <template #text>Are you sure to delete this data ?</template>
  </ReservationConfirm>
  <ReservationDataTable :data="data" :header="headers" :currentPage="currentPage" :custom-actions="customActions"/>
</template>

<script>
import { ref } from 'vue';
import HeaderContent from '@/components/HeaderContent.vue';
import ActionContent from '@/components/ActionContent.vue';
import ReservationStatistic from '@/components/StatisticData.vue';
import ReservationFilter from "./ReservationFilter.vue";
import ReservationForm from "./ReservationForm.vue";
import ReservationDataTable from '@/components/DataTable.vue';
import ReservationConfirm from '@/components/ModalDialog.vue';
import iconVoid from '../../../public/icons/rectangle-xmark.svg';
import iconReserved from '../../../public/icons/receipt.svg';
import iconCheckIn from '../../../public/icons/clipboard-check.svg';
import iconCheckOut from '../../../public/icons/door-open.svg';
import iconOverall from '../../../public/icons/square-poll-vertical.svg';

export default {
  components: {
    HeaderContent,
    ActionContent,
    ReservationForm,
    ReservationFilter,
    ReservationStatistic,
    ReservationConfirm,
    ReservationDataTable,
  },
  setup(){
    const modal = ref(false);
    const selected = ref(null);
    const modalFilter = ref(false);
    const modalConfirm = ref(false);
    const currentPage = ref(1)
    const types = ref(['Deluxe', 'Super Deluxe'])
    const sources = ref(['Direct Booking', 'Booking Online', 'Agent', 'Walk in'])
    const payments = ref(['DP', 'Lunas'])

    const data = ref([
      { 
        no: 1, 
        reservation_no: 'DR-01/11/02/2024', 
        type_room: 'Deluxe', 
        no_room: 'A3', 
        guest_name: 'Mr Bones', 
        arrival: '11/02/2025',
        departure: '13/02/2025',
        total_day: '2',
        payment_status: 'DP',
        paid: '600.000',
        balance: '1.000.000',
        status_reservation: {
          key: 'checkin',
          label: 'Check In'
        },
      },
      { 
        no: 2, 
        reservation_no: 'DR-02/11/02/2024', 
        type_room: 'Super Deluxe', 
        no_room: 'A2', 
        guest_name: 'Mr John', 
        arrival: '15/02/2025',
        departure: '18/02/2025',
        total_day: '3',
        payment_status: 'DP',
        paid: '700.000',
        balance: '900.000',
        status_reservation: {
          key: 'void',
          label: 'Void'
        },
      },
      { 
        no: 3, 
        reservation_no: 'DR-03/11/02/2024', 
        type_room: 'Honeymoon', 
        no_room: 'A4', 
        guest_name: 'Ms Vanessa', 
        arrival: '19/02/2025',
        departure: '21/02/2025',
        total_day: '2',
        payment_status: 'DP',
        paid: '1.000.000',
        balance: '500.000',
        status_reservation: {
          key: 'checkin',
          label: 'Check In'
        }
      },
      { 
        no: 4, 
        reservation_no: 'DR-04/11/02/2024', 
        type_room: 'Studio', 
        no_room: 'A1', 
        guest_name: 'Ms Reina', 
        arrival: '16/02/2025',
        departure: '19/02/2025',
        total_day: '3',
        payment_status: 'DP',
        paid: '900.000',
        balance: '800.000',
        status_reservation: {
          key: 'checkout',
          label: 'Check Out'
        }
      },
      { 
        no: 5, 
        reservation_no: 'DR-05/11/02/2024', 
        type_room: 'Family', 
        no_room: 'A5', 
        guest_name: 'Mr Steven', 
        arrival: '15/02/2025',
        departure: '20/02/2025',
        total_day: '5',
        payment_status: 'DP',
        paid: '800.000',
        balance: '700.000',
        status_reservation: {
          key: 'checkout_on',
          label: 'Checkout On'
        }
      },
      { 
        no: 6, 
        reservation_no: 'DR-05/11/02/2024', 
        type_room: 'Family', 
        no_room: 'A6', 
        guest_name: 'Mr Steven', 
        arrival: '15/02/2025',
        departure: '20/02/2025',
        total_day: '5',
        payment_status: 'DP',
        paid: '800.000',
        balance: '700.000',
        status_reservation: {
          key: 'inhouse',
          label: 'In House'
        }
      },
      { 
        no: 7, 
        reservation_no: 'DR-05/11/02/2024', 
        type_room: 'Family', 
        no_room: 'A5', 
        guest_name: 'Mr Steven', 
        arrival: '15/02/2025',
        departure: '20/02/2025',
        total_day: '5',
        payment_status: 'DP',
        paid: '800.000',
        balance: '700.000',
        status_reservation: {
          key: 'booked',
          label: 'Booked'
        }
      },
      { 
        no: 8, 
        reservation_no: 'DR-05/11/02/2024', 
        type_room: 'Family', 
        no_room: 'A5', 
        guest_name: 'Mr Steven', 
        arrival: '15/02/2025',
        departure: '20/02/2025',
        total_day: '5',
        payment_status: 'DP',
        paid: '800.000',
        balance: '700.000',
        status_reservation: {
          key: 'available',
          label: 'Available'
        }
      },
      { 
        no: 8, 
        reservation_no: 'DR-05/11/02/2024', 
        type_room: 'Family', 
        no_room: 'A5', 
        guest_name: 'Mr Steven', 
        arrival: '15/02/2025',
        departure: '20/02/2025',
        total_day: '5',
        payment_status: 'DP',
        paid: '800.000',
        balance: '700.000',
        status_reservation: {
          key: 'available',
          label: 'Available'
        }
      },
      { 
        no: 8, 
        reservation_no: 'DR-05/11/02/2024', 
        type_room: 'Family', 
        no_room: 'A5', 
        guest_name: 'Mr Steven', 
        arrival: '15/02/2025',
        departure: '20/02/2025',
        total_day: '5',
        payment_status: 'DP',
        paid: '800.000',
        balance: '700.000',
        status_reservation: {
          key: 'available',
          label: 'Available'
        }
      },
      { 
        no: 8, 
        reservation_no: 'DR-05/11/02/2024', 
        type_room: 'Family', 
        no_room: 'A5', 
        guest_name: 'Mr Steven', 
        arrival: '15/02/2025',
        departure: '20/02/2025',
        total_day: '5',
        payment_status: 'DP',
        paid: '800.000',
        balance: '700.000',
        status_reservation: {
          key: 'available',
          label: 'Available'
        }
      },
    ]);
    
    const headers = ref([
      {
        key: 'no',
        label: 'No',
        sortable: true,
      },
      {
        key: 'reservation_no',
        label: 'Reservation No',
        sortable: true,
      },
      {
        key: 'type_room',
        label: 'Room Type',
        sortable: true,
      },
      {
        key: 'no_room',
        label: 'Room Number',
        sortable: true,
      },
      {
        key: 'guest_name',
        label: 'Guest Name', 
        sortable: true,
      },
      {
        key: 'arrival',
        label: 'Arrival', 
        sortable: true,
      },
      {
        key: 'departure',
        label: 'Departure', 
        sortable: true,
      },
      {
        key: 'total_day',
        label: 'Total Day', 
        sortable: true,
      },
      {
        key: 'payment_status',
        label: 'Payment Status', 
        sortable: true,
      },
      {
        key: 'paid',
        label: 'Paid', 
        sortable: false,
      },
      {
        key: 'balance',
        label: 'Balance', 
        sortable: false,
      },
      {
        key: 'status_reservation',
        label: 'Status', 
        sortable: false,
      },
      {
        key: 'action',
        label: 'Actions'
      },
      
    ])

    const customActions = ref([
      {
          label: 'Extra Charge',
          variant: 'warning',
          icon: 'fas fa-bolt',
          action: (item) => {
            modal.value = true
          console.log('Extra charge action clicked for:', item);
          // Implement your extra charge logic here
          }
      },
      {
          label: 'Reschedule',
          variant: 'orange',
          icon: 'fas fa-calendar-day',
          action: (item) => {
          console.log('Reschedule action clicked for:', item);
          // Implement your Reschedule logic here
          }
      },
      {
          label: 'Edit',
          variant: 'success',
          icon: 'fas fa-edit',
          action: (item) => {
          console.log('Edit action clicked for:', item);
          // Implement your edit logic here
          }
      },
      {
          label: 'Delete',
          variant: 'danger',
          icon: 'fas fa-trash',
          action: (item) => {
            modalConfirm.value = true
          console.log('Delete action clicked for:', item);
          // Implement your delete logic here
          }
      },
      
    ]);

    const statistics = ref([
      {
        label: 'Total',
        key: 'Reserve',
        value: 23,
        color: 'primary',
        icon: iconReserved,
      },
      {
        label: 'Total',
        key: 'Check In',
        value: 13,
        color: 'success',
        icon: iconCheckIn,
      },
      {
        label: 'Total',
        key: 'Check Out',
        value: 13,
        color: 'warning',
        icon: iconCheckOut,
      },
      {
        label: 'Total',
        key: 'Void',
        value: 13,
        color: 'danger',
        icon: iconVoid,
      },
      {
        label: 'Total',
        key: 'Overall',
        value: 92,
        color: 'primary',
        icon: iconOverall,
      },
      // {
      //   label: 'Total',
      //   key: 'Reservation Daily',
      //   value: 7,
      //   color: 'primary',
      //   icon: iconVoid,
      // },
      // {
      //   label: 'Total',
      //   key: 'Reservation Weekly',
      //   value: 7,
      //   color: 'primary',
      // },
      // {
      //   label: 'Total',
      //   key: 'Reservation Monthly',
      //   value: 7,
      //   color: 'primary',
      // },
      // {
      //   label: 'Total',
      //   key: 'Reservation Ongoing',
      //   value: 7,
      //   color: 'primary',
      // },
    ])
    const date = new Date();
    const getCurrentDate = `${date.getFullYear()}-0${date.getMonth()+1}-${date.getDate()}`
    const startDate = ref(getCurrentDate);
    const endDate = ref(getCurrentDate);

    return {
      getCurrentDate,
      startDate,
      endDate,
      sources,
      selected,
      modal,
      data,
      headers,
      types,
      payments,
      statistics,
      modalFilter,
      modalConfirm,
      currentPage,
      customActions
    }; 
  }
}

</script>